export default 'Plan pluriannuel de travaux (PPT) obligatoire : contenu, calendrier et articulation avec la rénovation énergétique. Accompagnement copropriétés Solution Éco France.';
